import React, { useState } from 'react';
import { Button, Input, Row, Col, Form, InputNumber } from 'antd';
import { EyeTwoTone, EyeFilled, CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DeleteStorage from './DeleteStorage';
// import Form from './FormStyled';
import { useForm } from 'react-hook-form';
import { RHFInput } from 'react-hook-form-input';
import { yupResolver } from '@hookform/resolvers';
import * as yup from 'yup';

function StorageForm({
  open,
  modal,
  create,
  setVisible,
  visible,
  deleteData,
  data,
  edit,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const { t } = useTranslation();
  const SignupSchema = yup.object().shape({
    name: yup.string().required(),
    identifier: yup.string().required(),
    address: yup.string().required(),
    manual_url: yup.string().required(),
    latitude: yup.number().required(),
    longitude: yup.number().required(),
    wifi_guest_ssid: yup.string().required(),
    wifi_guest_password: yup.string().required(),
    wifi_employee_ssid: yup.string().required(),
    wifi_employee_password: yup.string().required(),
    phone: yup.number().required(),
  });
  const [form] = Form.useForm();

  // const {
  //   handleSubmit,
  //   register,
  //   setValue,
  //   formState: { errors },
  // } = useForm({
  //   resolver: yupResolver(SignupSchema),
  // });

  const newStorage = (data) => {
    create({ ...data, phone: String(data.phone) });
    setVisible(!visible);
  };

  const editStorage = (params) => {
    params.id = data.id;
    edit({ ...params, phone: String(params.phone) });
    setVisible(!open);
  };

  return (
    <div className="">
      <Form
        className="pb-20 pt-20 pl-26 pr-20  bg-white rounded-md shadow-standart"
        name="basic"
        // onSubmit={((data) => {
        //   open ? editStorage(data) : newStorage(data);
        // })}
        onFinish={newStorage}
        initialValues={data ? { name: data.name } : {}}
      >
        <Row gutter={[16, 2]}>
          <Col span={24}>
            <div className="relative">
              <Form.Item
                name={['name']}
                label={t('title')}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
          <Col span={24}>
            <div className="relative">
              <Form.Item
                name={['identifier']}
                label={t('id')}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </Col>
          <Col span={24}>
            <div className="relative">
              <Form.Item
                name={['address']}
                label={t('address')}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input defaultValue={data ? data.address : ''} />
              </Form.Item>
            </div>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div className="relative">
                  <Form.Item
                    name={['latitude']}
                    label={t('coordinates')}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <InputNumber defaultValue={data ? data.latitude : ''} />
                    {/* 
                    {errors.latitude &&
                      (errors.latitude.type === 'typeError' ? (
                        <span className="validate">{t('reqFieldNumber')}</span>
                      ) : (
                        <span className="validate">{t('reqField')}</span>
                      ))} */}
                  </Form.Item>
                </div>
              </Col>
              <Col className="flex items-end" span={12}>
                <div className="relative">
                  <Form.Item
                    name={['longitude']}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <InputNumber defaultValue={data ? data.longitude : ''} />

                    {/* {errors.longitude &&
                      (errors.longitude.type === 'typeError' ? (
                        <span className="validate">{t('reqFieldNumber')}</span>
                      ) : (
                        <span className="validate">{t('reqField')}</span>
                      ))} */}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Col>
          <Col className="mb-15" span={24}>
            <div className="relative">
              <Form.Item
                name={['manual_url']}
                label={t('lintToInstruction')}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input defaultValue={data ? data.manual_url : ''} />

                {/* {errors.manual_url && (
                  <span className="validate">{t('reqField')}</span>
                )} */}
              </Form.Item>
            </div>
          </Col>
          <Col span={24}>
            <div className="relative">
              <Form.Item
                name={['phone']}
                label={t('numPhone')}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <InputNumber defaultValue={data ? data.phone : ''}  style={{ width: '100%' }} />
              </Form.Item>
            </div>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div className="relative">
                  <Form.Item
                    name={['wifi_guest_ssid']}
                    label={t('nameWifi')}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input defaultValue={data ? data.wifi_guest_ssid : ''} />

                    {/* {errors.wifi_guest_ssid && (
                      <span className="validate">{t('reqField')}</span>
                    )} */}
                  </Form.Item>
                </div>
              </Col>
              <Col className="flex items-end" span={12}>
                <div className="relative">
                  <Form.Item
                    name={['wifi_guest_password']}
                    // label={t('nameWifi')}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input.Password
                      defaultValue={data ? data.wifi_guest_password : ''}
                    />

                    {/* {errors.wifi_guest_password && (
                      <span className="validate">{t('reqField')}</span>
                    )} */}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Col>
          {/* <div className="w-full  flex justify-end -mt-2 relative">
            <Button type="link" className="change_pass">
              <span className="validate">{t('changePass')}</span>
            </Button>
          </div> */}
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div className="relative">
                  <Form.Item
                    name={['wifi_employee_ssid']}
                    label={t('nameWifiStaff')}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input defaultValue={data ? data.wifi_employee_ssid : ''} />

                    {/* {errors.wifi_employee_ssid && (
                      <span className="validate">{t('reqField')}</span>
                    )} */}
                  </Form.Item>
                </div>
              </Col>
              <Col className="flex items-end" span={12}>
                <div className="relative">
                  <Form.Item
                    name={['wifi_employee_password']}
                    // label={t('nameWifiStaff')}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input.Password
                      defaultValue={data ? data.wifi_employee_password : ''}
                    />

                    {/* {errors.wifi_employee_password && (
                      <span className="validate">{t('reqField')}</span>
                    )} */}
                  </Form.Item>
                </div>
              </Col>
              {/* <div className="w-full  flex justify-end -mt-2 relative">
                <Button type="link" className="change_pass">
                  <span>{t('changePass')}</span>
                </Button>
              </div> */}
            </Row>
          </Col>
          <Col className="mt-5" span={open ? 12 : 24}>
            <div className={`flex ${open ? 'justify-end' : 'justify-center'}`}>
              <Button
                className={`${open ? 'pr-0 action create' : 'action create'}`}
                type="link"
                htmlType="submit"
              >
                <span>{open ? t('apply') : t('create')}</span>
              </Button>
            </div>
          </Col>
          {open ? (
            <Col className="mt-5" span={12}>
              <div className="flex mt-12 cursor-pointer justify-start">
                <div
                  onClick={() => {
                    setDeleteVisible(!deleteVisible);
                  }}
                  className="pl-0 action delete"
                  type="link"
                  htmltype="submit"
                >
                  <span>{t('delete')}</span>
                </div>
              </div>
            </Col>
          ) : null}
        </Row>
        {deleteVisible && (
          <DeleteStorage
            deleteData={deleteData}
            id={data ? data.id : null}
            deleteVisible={deleteVisible}
            setDeleteVisible={setDeleteVisible}
            open={open}
            setVisible={setVisible}
          />
        )}
        {!modal && (
          <CloseOutlined
            onClick={() => {
              setVisible(!open);
            }}
          />
        )}
      </Form>
    </div>
  );
}

StorageForm.propTypes = {};

export default StorageForm;
